import React from 'react';
import './TeacherDirections.scss'

export class TeacherDirections extends React.Component {

  printWindow = () => {
    const currentTitle = document.title;
    document.title = "Teacher's Directions";
    window.print();
    document.title = currentTitle;
  }

render() {
    return (
      <div className="teacherDirectionsContainer">
        <div className="teacherDirections">
          <div className="column">
            <p>Program Objective</p>
            <ol>
              <li>Students will commit multiplication facts to long-term memory with rapid recall.</li>
              <li>Students will develop a positive attitude toward math through the program’s success-based and engaging approach.</li>
              <li>Students will gain the foundational skills (the “nuts and bolts”) needed for math by mastering basic facts.</li>
              <li>Students will apply these skills to future mathematical concepts including division, fractions, algebra, and beyond.</li>
            </ol>
            <p>Student Login Instructions</p>
            <ul className="noBullets">
              <li>After the welcome screen, students log in using the teacher’s username <b>or</b> email address.</li>
            </ul>
            <p>Adding a New Student</p>
            <ol>
              <li>Enter the student’s unique name in the Student Name field.</li>
              <li>On first login, the message will appear:
                <br/><i>"Student not found. Would you like to add __________?"</i></li>
              <li>Click <b>Yes</b> to create the account.</li>
              <li>If the name is misspelled, click <b>No</b> and re-enter the correct spelling.
                <br/><b>Note:</b> Student names are not case-sensitive.
                <br/>Example: <i>John L. and john l. are treated as the same student.</i>
              </li>
            </ol>

            <p>Student Lesson List</p>
            <ul className="noBullets">
              <li>After logging in, students are directed to the Lesson List which shows completed lessons. Students can resume lessons indicated by an empty or half-filled circle.</li>
              <li>Students should remember to log in using their original login name to assure progress is properly tracked.</li>
            </ul>

            <p>Progress Icons</p>
            <ul>
              <li><b>Empty Circle</b> = Ready to begin.</li>
              <li><b>Half-Filled Circle</b> = Started but not completed.</li>
              <li><b>Filled Circle</b> = Completed.</li>
            </ul>

            <p>Facts Column</p>
            <ul className="noBullets">
              <li>The facts column shows the facts covered in each lesson.</li>
              <li><br/>Students should complete lessons in numerical order to ensure that progress check quizzes will include questions that have been learned.</li>  
            </ul>

            <p>Clearing a Lesson</p>
            <ul className="noBullets">
              <li>If a student needs additional practice or you would like them to retake a test, use the Clear button located in the Teacher Dashboard.</li>
            </ul>

            <p>Progress Reports</p>
            <ul className="noBullets">
              <li>The Progress Report keeps a running record of student performance, including:</li>
              <ul>
                <li>Lessons completed</li>
                <li>Date completed</li>
                <li>Test scores (number correct and percentage)</li>
                <li>Time elapsed during testing</li>
                <li>Access the student’s progress report by clicking on the Details button next to the student name in the Teacher’s Dashboard.</li>
              </ul>
            </ul>

            <p>Comparing Repeat Tests</p>
            <ul className="noBullets">
              <li>Several tests are taken twice during the program.</li>
              <li>The second score should show:</li>
              <ul>
                <li>Faster completion time</li>
                <li>Higher score</li>
              </ul>
              <li>If improvement is not shown, the student should repeat the related lesson. Repeat tests are used for practice for the ones, twos, fives, and nines. These include:</li>
              <ul>
                <li>One Two Buckle My Shoe</li>
                <li>Man Alive Try the Fives</li>
                <li>Nines in a Line</li>
              </ul>
            </ul>

          </div>
          <div className="column">

            <p>Printing Tests and Reports</p>
            <ul className="noBullets">
              <li>Blank pre-tests, post-tests, and progress check quizzes may be printed from the <b>Details</b> button on the Teacher’s Dashboard.</li>
              <li>Individual Student Progress Reports may also be printed.</li>
            </ul>

            <p>Use of Pre-test and Post-test</p>
            <ul className="noBullets">
              <li>The pre-test measures beginning skill level and students are not expected to know all answers.</li>
              <li>The post-test demonstrates student growth. Many students score 95% or higher by program completion.</li>
              <li>Completed tests may be printed from the Details on the Teacher’s Dashboard providing the test was taken on our new platform effective any time after June 13, 2026.</li>
              <li>Completed pre-tests and post-tests can be printed for:</li>
              <ul>
                <li>Parent-teacher conferences</li>
                <li>Progress documentation</li>
                <li>Identifying facts that still need review</li>
              </ul>
            </ul>

            <p>Teacher Dashboard</p>
            <ul className="noBullets">
            <li>Use the <b>Teacher Login</b> to access the <b>Teacher Dashboard</b>.</li>
            <li>There you can:</li>
            <ul>
              <li>View all students</li>
              <li>View student progress reports - click Details</li>
              <li>View tests that have been taken to see detailed results.</li>
              <li>Print progress reports</li>
              <li>Print blank tests</li>
              <li>Reset lessons using the Clear button</li>
              <li>Add, delete, or edit student names - you can edit the name of a student without losing their scores or progress. 
                To edit a students name click on the name in the teacher dashboard, edit as desired and click the check. 
                To exit edit mode click the red x.</li>
            </ul>
          </ul>

          <p>Subscription Details</p>
          <ul className="noBullets">
            <li>Online Times Alive memberships are billed monthly or yearly and can be cancelled at anytime by visiting: <b>citycreek.com/my-account</b></li>
          </ul>

          <p>Student Seat Limit</p>
          <ul className="noBullets">
            <li>Each teacher account will include seats for up to <b>30 students</b>. When the limit is reached, you must delete students to add new ones. Progress details will be erased for all deleted students.</li>
          </ul>

          <p>Terms of Use</p>
          <ul className="noBullets">
            <li>Sharing accounts among multiple teachers, schools, or districts is a violation of the terms of agreement unless a school license has been purchased. School licenses are good for up to 10 teacher classrooms with 30 students each.</li>
          </ul>

          <p>Award Winning Program Encourages Success</p>
          <ul className="noBullets">
            <li>Times Alive! is designed to create confidence, independence, and lasting success in mathematics by making multiplication facts memorable, fun, and automatic.</li>
            <li>When students master the basics, everything else becomes easier.</li>
          </ul>

          <p>Times Tables the Fun Way Book for Kids</p>
          <ul className="noBullets">
            <li>Online Times Alive is based on the award winning book Times Tables the Fun Way Book for Kids. The book is handy to have as a hard copy while traveling or for bed-time stories. It contains all the stories in the Online Times Alive Program and covers the 0s-9s. It serves as a text book for school classrooms and at home.</li>
            <li> It is available at <a href="https://www.citycreek.com" target="_blank" rel="noopener noreferrer">CityCreek.com</a> or on <a href="https://amzn.to/4elRiaq" target="_blank" rel="noopener noreferrer">Amazon</a>.</li>
          </ul>

          </div>
        </div>
        <div className="teacherDirectionsButtons">
          <button className="printButton" onClick={() => this.printWindow()}>PRINT</button>
          <button className="closeButton" onClick={this.props.onClose}>CLOSE</button>
        </div>
      </div>
    );
  }
}
